import React, { useEffect, useState, useCallback } from 'react';
import {
  Modal,
  Card,
  List,
  Typography,
  Button,
  Popconfirm,
  Tag,
  message,
  Input,
  Space,
  Row,
  Col,
  Spin,
  Select,
  Pagination,
} from 'antd';
import axios from 'axios';
import { endpoints } from './caminhoApi';

const { Text, Paragraph } = Typography;
const { Option } = Select;

export default function AdminPanelModal({ visible, onClose }) {
  const [id, setId] = useState(sessionStorage.getItem('id') || '');
  const [senha, setSenha] = useState(sessionStorage.getItem('senha') || '');
  const [authenticated, setAuthenticated] = useState(false);
  const [autoAuthTried, setAutoAuthTried] = useState(false);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [worldFilter, setWorldFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const handleAuthentication = useCallback(async (auto = false) => {
    const storedAuthenticated = sessionStorage.getItem('authenticated') === 'true';

    if (storedAuthenticated) {
      setAuthenticated(true);
      return;
    }

    if (!id || !senha) {
      if (!auto) message.error("Preencha ID e senha!");
      return;
    }

    try {
      const response = await axios.post(endpoints.loginEndpoint, { id, senha });

      if (response.status === 200) {
        setAuthenticated(true);
        if (!auto) message.success("Autenticação bem-sucedida.");

        sessionStorage.setItem('authenticated', 'true');
        sessionStorage.setItem('id', id);
        sessionStorage.setItem('senha', senha);
      }
    } catch (error) {
      if (!auto) {
        message.error("ID ou senha incorretos.");
      }
    }
  }, [id, senha]); // memoiza a função apenas quando id ou senha mudarem


  useEffect(() => {
    if (visible && !authenticated && !autoAuthTried) {
      if (id && senha) {
        handleAuthentication(true);
      }
      setAutoAuthTried(true);
    }
  }, [visible, authenticated, autoAuthTried, id, senha, handleAuthentication]);

  
    useEffect(() => {
      if (authenticated && visible) {
        loadData();
      }
    }, [authenticated, visible]);
  
    useEffect(() => {
      const storedAuthenticated = sessionStorage.getItem('authenticated') === 'true';
      
      if (storedAuthenticated) {
        setAuthenticated(true);
      } else if (id && senha) {
        handleAuthentication(true);
      }

      setAutoAuthTried(true);
    }, [visible, id, senha, handleAuthentication]); // agora ESLint não reclama

  const handleClose = () => {
    onClose();
    setAuthenticated(false);
    setAutoAuthTried(false);
    setCurrentPage(1);
    setSearchTerm('');
    setStatusFilter('');
    setWorldFilter('');
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${endpoints.backendBase}/api/admin/get-all`);
      setEntries(res.data.entries || []);
    } catch {
      message.error('Erro ao carregar dados do admin');
    } finally {
      setLoading(false);
    }
  };

  const approve = async (id) => {
  try {
    await axios.post(`${endpoints.backendBase}/api/admin/approve`, { id });
    message.success('Solicitação aprovada');
    loadData();
  } catch {
    message.error('Erro ao aprovar');
  }
};

const revoke = async (id) => {
  try {
    await axios.post(`${endpoints.backendBase}/api/admin/revoke`, { id });
    message.success('Token revogado');
    loadData();
  } catch {
    message.error('Erro ao revogar');
  }
};

  const filteredEntries = entries
    .filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (!statusFilter || item.status === statusFilter) &&
      (!worldFilter || item.world === worldFilter)
    )
    .sort((a, b) => {
    // Primeiro, ordena por status: 'request' primeiro
    if (a.status === 'request' && b.status !== 'request') return -1;
    if (a.status !== 'request' && b.status === 'request') return 1;

    // Depois, ordena por data decrescente
    return new Date(b.date) - new Date(a.date);
  });

  const paginatedEntries = filteredEntries.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <Modal
      title="Panel de accesos"
      open={visible}
      onCancel={handleClose}
      footer={null}
      width={650}
      style={{ top: 40 }}
      styles={{
        body: {
          maxHeight: '75vh',
          overflowY: 'auto',
          padding: 15,
          borderRadius: 10,
        },
      }}
    >

      {!authenticated ? (
        <div style={{ maxWidth: 300, margin: 'auto' }}>
          <Input
            placeholder="ID"
            value={id}
            onChange={(e) => setId(e.target.value)}
            style={{ marginBottom: 8 }}
          />
          <Input.Password
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            style={{ marginBottom: 8 }}
          />
          <Button type="primary" block onClick={() => handleAuthentication()}>
            Autenticar
          </Button>
        </div>
      ) : loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          {/* Filtros */}
          <Row gutter={8} style={{ marginBottom: 16 }}>
            <Col flex="auto">
              <Input.Search
                placeholder="Buscar por nome..."
                allowClear
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col flex="160px">
              <Select
                style={{ width: '100%' }}
                placeholder="Status"
                allowClear
                onChange={(value) => {
                  setStatusFilter(value);
                  setCurrentPage(1);
                }}
              >
                <Option value="request">Pendente</Option>
                <Option value="approved">Aprovado</Option>
                <Option value="revoked">Revogado</Option>
              </Select>
            </Col>
            <Col flex="140px">
              <Select
                style={{ width: '100%' }}
                placeholder="Mundo"
                allowClear
                onChange={(value) => {
                  setWorldFilter(value);
                  setCurrentPage(1);
                }}
              >
                <Option value="Solidera">Solidera</Option>
                <Option value="Havera">Havera</Option>
              </Select>
            </Col>
          </Row>

          <List
            grid={{ gutter: 12, column: 1 }}
            locale={{ emptyText: 'Nenhum item encontrado' }}
            dataSource={paginatedEntries}
            renderItem={(item) => {
              const tagColor =
                item.status === 'request' ? 'blue' : item.status === 'approved' ? 'green' : 'red';
              const tagLabel =
                item.status === 'request' ? 'Pendente' : item.status === 'approved' ? 'Aprovado' : 'Revogado';
              const showApprove = item.status === 'request';
              const showRevoke = item.status !== 'revoked';

              const actions = [];

              if (showApprove) {
                actions.push(
                  <Popconfirm
                    key="approve"
                    title="Confirmar aprovação?"
                    onConfirm={() => approve(item.id)}
                    okText="Sim"
                    cancelText="Não"
                  >
                    <Button type="primary" size="small">Aprovar</Button>
                  </Popconfirm>
                );
              }

              if (showRevoke) {
                actions.push(
                  <Popconfirm
                    key="revoke"
                    title="Revogar este token?"
                    onConfirm={() => revoke(item.id)}
                    okText="Sim"
                    cancelText="Não"
                  >
                    <Button danger size="small">Revogar</Button>
                  </Popconfirm>
                );
              }

              return (
                <List.Item>
                  <Card
                    size="small"
                    style={{
                      borderRadius: 10,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
                    }}
                    title={
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Space>
                            <Text strong>Nombre:{' '} {item.name}</Text>
                            <Text>
                              Char:{' '}
                              {item.characterName ? (
                                <Typography.Link
                                  href={`https://www.tibia.com/community/?name=${encodeURIComponent(item.characterName)}`}
                                  target="_blank"
                                >
                                  {item.characterName}
                                </Typography.Link>
                              ) : (
                                '-'
                              )}
                            </Text>
                          </Space>
                        </Col>
                        <Col>
                          <Tag color={tagColor}>{tagLabel}</Tag>
                        </Col>
                      </Row>
                    }
                    actions={actions.length > 0 ? actions : undefined}
                  >
                    <Paragraph style={{ marginBottom: 8 }}>
                      <strong>Mensagem:</strong> {item.message || 'Sem mensagem'}
                    </Paragraph>
                    <Paragraph type="secondary" style={{ fontSize: 12, marginBottom: 0 }}>
                      Mundo: {item.world || '—'} | Plataforma: {item.platform || '—'} | Data:{' '}
                      {item.date ? new Date(item.date).toISOString().slice(0, 16).replace('T', ' ') : '—'}
                    </Paragraph>
                  </Card>
                </List.Item>
              );
            }}
          />

          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Pagination
              current={currentPage}
              total={filteredEntries.length}
              pageSize={pageSize}
              onChange={(page) => setCurrentPage(page)}
              size="small"
              showSizeChanger={false}
            />
          </div>
        </>
      )}
    </Modal>
  );
}